<template lang="pug">
div(v-if="data.totalReviews > 0" class="inline-block relative font-bold")
    div(
        v-if="this.$device.isSmall"
        @click="$overlay.show('reviews')"
        class="z-10 absolute top-0 bottom-0 right-0 left-0 cursor-pointer"
    )
    a(
        v-else
        href='#'
        v-scroll-to="'#scrollTarget-reviews'"
        aria-label="Show Reviews"
        class="z-10 absolute top-0 bottom-0 right-0 left-0 cursor-pointer"
    )
    Stars(:averageRating="data.averageRating" :totalReviews="data.totalReviews")
</template>

<script>
import Stars from '@/components/stars'

export default {
    name: 'Reviews',
    components: {
        Stars,
    },
    props: {
        data: {
            required: true,
            type: Object,
        },
    },
}
</script>
